{
  "REGISTER": {
    "TRY_WOOT": "ایجاد حساب کاربری",
    "GET_STARTED": "Get started with Chatwoot",
    "TITLE": "ثبت نام",
    "TESTIMONIAL_HEADER": "تنها چیزی که لازم است یک قدم برای حرکت به جلو است",
    "TESTIMONIAL_CONTENT": "شما یک قدم تا جذب مشتریان خود، حفظ آنها و یافتن مشتریان جدید فاصله دارید.",
    "TERMS_ACCEPT": "با ایجاد یک حساب کاربری، با <a href=\"https://www.chatwoot.com/terms\">T & C</a> و <a href=\"https://www.chatwoot.com/ ما موافقت می کنید privacy-policy\">خط مشی رازداری</a>",
    "OAUTH": {
      "GOOGLE_SIGNUP": "با گوگل ثبت نام کنید"
    },
    "COMPANY_NAME": {
      "LABEL": "نام شرکت",
      "PLACEHOLDER": "نام شرکت خود را وارد کنید. به عنوان مثال: شرکت وین",
      "ERROR": "نام شرکت خیلی کوتاه است"
    },
    "FULL_NAME": {
      "LABEL": "نام کامل",
      "PLACEHOLDER": "نام کامل خود را وارد کنید به عنوان مثال: گودرز جعفری",
      "ERROR": "نام کامل خیلی کوتاه است"
    },
    "EMAIL": {
      "LABEL": "ایمیل کاری",
      "PLACEHOLDER": "Enter your work email address. E.g., bruce{'@'}wayne{'.'}enterprises",
      "ERROR": "لطفا یک آدرس ایمیل کاری معتبر وارد کنید"
    },
    "PASSWORD": {
      "LABEL": "رمز عبور",
      "PLACEHOLDER": "رمز عبور",
      "ERROR": "رمز عبور خیلی کوتاه است",
      "IS_INVALID_PASSWORD": "رمز عبور باید شامل حداقل ۱ حرف بزرگ، ۱ حرف کوچک، ۱ عدد و ۱ کاراکتر خاص باشد",
      "REQUIREMENTS_LENGTH": "At least 6 characters long",
      "REQUIREMENTS_UPPERCASE": "At least one uppercase letter",
      "REQUIREMENTS_LOWERCASE": "At least one lowercase letter",
      "REQUIREMENTS_NUMBER": "At least one number",
      "REQUIREMENTS_SPECIAL": "At least one special character"
    },
    "CONFIRM_PASSWORD": {
      "LABEL": "تکرار رمز عبور",
      "PLACEHOLDER": "تکرار رمز عبور",
      "ERROR": "تکرار رمز عبور می‌بایست با رمز عبور یکسان باشد."
    },
    "API": {
      "SUCCESS_MESSAGE": "Registration Successful",
      "ERROR_MESSAGE": "ارتباط با سرور برقرار نشد، لطفا بعدا امتحان کنید"
    },
    "SUBMIT": "ایجاد حساب کاربری",
    "HAVE_AN_ACCOUNT": "از قبل حساب‌کاربری دارید؟",
    "VERIFY_EMAIL": {
      "TITLE": "Check your inbox",
      "DESCRIPTION": "We sent a verification link to {email}. Click the link to verify your email and get started.",
      "RESEND": "ارسال مجدد ایمیل تایید",
      "RESEND_SUCCESS": "Verification email sent. Please check your inbox.",
      "RESEND_ERROR": "Could not send verification email. Please try again."
    }
  }
}
